import { Component, OnInit } from '@angular/core';
import { MemberService } from 'src/app/services/member.service';
import { Input } from '@angular/core';
import { TeamService } from 'src/app/services/team.service';
import { TeamSeasonService } from 'src/app/services/team-season.service';
import { ActivatedRoute } from '@angular/router';
import { Team } from 'src/app/model/team';
import { SeasonService } from 'src/app/services/season.service';
import { TeamSeason } from 'src/app/model/team-season';
import { Member } from 'src/app/model/member';
import { Season } from 'src/app/model/season';

@Component({
  selector: 'team',
  templateUrl: 'team.html',
  styles: [
    "#team-photo { width: 100%; padding: 0; }"
  ]
})

export class TeamComponent implements OnInit {
  team: Team;
  teamSeason: TeamSeason;
  season: Season;
  players: Member[];

  constructor(
    private readonly teamService: TeamService,
    private readonly seasonService: SeasonService,
    private readonly teamSeasonService: TeamSeasonService,
    private readonly memberService: MemberService,
    private readonly route: ActivatedRoute
  ) {
    this.route.paramMap.subscribe(() => {
      this.ngOnInit();
    })
  }

  ngOnInit() {
    this.getTeam();
  }

  getTeam(): void {
    // get member id from route
    const teamSeasonId = this.route.snapshot.paramMap.get("id");

    this.teamSeasonService.getTeamSeasons().subscribe(teamSeasons => {
      // get team season
      this.teamSeason = teamSeasons.find(teamSeason => teamSeason.teamSeasonId === teamSeasonId);
      // get team
      this.teamService.getTeams().subscribe(teams => {
        this.team = teams.find(team => team.teamId === this.teamSeason.teamId);
      });
      // get season
      this.seasonService.getSeasons().subscribe(seasons => {
        this.season = seasons.find(season => season.seasonId === this.teamSeason.seasonId);
      });

      // get team season members
      this.memberService.getMembers().subscribe(members => {
        this.players = this.teamSeason.players.sort(player => player.position).map(player => members.find(member => member.memberId === player.memberId));
      });
    });
  }

  private getXttvTableUrl(): string {
    return `https://oettv.xttv.at/ed/tabelle.inc.php?lid=${this.teamSeason.xttvLid}&highVid=560`;
  }

  private getXttvTableHeight(): string {
    return `${131 + this.teamSeason.totalTeamsCount * 20}px`;
  }

  private getXttvScheduleUrl(): string {
    if (this.teamSeason.xttvTid)
      return `https://oettv.xttv.at/ed/spiele.inc.php?lid=${this.teamSeason.xttvLid}&tid=${this.teamSeason.xttvTid}&highVid=560&hideColumns=dg,o,a,d&showTitel=N`;
    else
      return `https://oettv.xttv.at/ed/spiele.inc.php?lid=${this.teamSeason.xttvLid}&vid=560&highVid=560&hideColumns=dg,o,a,d&showTitel=N`;
  }

  private getXttvScheduleHeight(): string {
    return `${122 + this.getScheduleMultiplicator() * (this.teamSeason.totalTeamsCount - 1) * 25}px`;
  }

  private getScheduleMultiplicator(): number {
    return this.teamSeason.twoLegged ? 2 : 1;
  }
}
